import React from 'react'
import { useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyTextSize, DisplaySize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { BodyText } from '../bodyText/BodyText'
import { Display } from '../display/Display'
import { ChevronIcon, ChevronIconDirection } from '../icons/ChevronIcon'
import { PressableOpacity } from '../pressableOpacity/PressableOpacity'

export interface RecommendedArticleCardProps {
  id: string
  title: string
  onPress: () => void
}

const CardContainer = styled(PressableOpacity)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing['12px'],
  padding: theme.spacing['16px'],
  borderRadius: '8px',
  backgroundColor: theme.colors.backgroundElement,
  flexBasis: '100%',
  flexShrink: 1,
}))

const CardContent = styled.View({
  flex: 1,
  paddingRight: 8,
})

export const RecommendedArticleCard: React.FC<RecommendedArticleCardProps> = ({ id, title, onPress }) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme() as ThemeType

  return (
    <CardContainer
      testID={tID(`RecommendedArticleCard-${id}`)}
      onPress={onPress}
      accessibilityRole='button'
      accessibilityLabel={formatMessage(
        { defaultMessage: 'Read recommended article: {title}', description: 'Accessibility label for article card' },
        { title },
      )}
    >
      <CardContent>
        <Display
          text={formatMessage({
            defaultMessage: 'Recommended',
            description: 'Label for recommended articles in Care Insights',
          })}
          size={DisplaySize.EYEBROW}
          color={colors.textInactive}
          testID={tID('RecommendedArticleCard-label')}
        />
        <BodyText text={title} size={BodyTextSize.DEFAULT} />
      </CardContent>
      <ChevronIcon fillColor={colors.iconDefault} size={20} direction={ChevronIconDirection.RIGHT} />
    </CardContainer>
  )
}

export default RecommendedArticleCard
